/*eslint-disable*/
import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';

function PdfActionButton(props) {
    
    const [openBox, setopenBox] = useState(false)

    let handleGeneratePdf = (e) => {
        let purchaseOrder = props.data
        console.log("Purchase Order Data", props)
        const getGeneratedPdf = purchaseOrder.getGeneratedPdf
        const refNo = purchaseOrder.refNo
        getGeneratedPdf(refNo)
    }


    return (
        <>
            <Button onClick={handleGeneratePdf} basic size="mini" type="button" icon> <Icon name="file pdf" color="red" /></Button>
        </>
    )
}

export default PdfActionButton
